var MeleeCombat = {
    handle: "melee_combat",
    
    abilities: {
        slash: {
            handle: "slash",
            unlockLevel: 1 
        },
        
        slam: {
            handle: "slam",
            unlockLevel: 2 
        },

        taunt: {
            handle: "taunt",
            unlockLevel: 10 
        },

        armor_break: {
            handle: "armor_break",
            unlockLevel: 18 
        },
            
        roundhouse: {
            handle: "roundhouse",
            unlockLevel: 26
        },

        mortal_strike: {
            handle: "mortal_strike",
            unlockLevel: 34
        },  

        sky_hammer: {
            handle: "sky_hammer",
            unlockLevel: 42 
        }
    }
};
module.exports = MeleeCombat;